import { useState } from 'react';
import RegistrationModal from '@/components/feature/RegistrationModal';

export default function FinalCTA() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <section id="cta-final" className="bg-[#F7F6FF] px-4 py-14 md:px-6 md:py-24">
        <div className="mx-auto max-w-5xl overflow-hidden rounded-[34px] bg-gradient-to-br from-[#5B51C9] to-[#27205F] p-7 text-center text-white shadow-2xl shadow-[#534AB7]/25 md:p-14">
          <span className="inline-flex rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-black uppercase tracking-wide text-[#D9D5FF]">
            Empieza hoy
          </span>
          <h2 className="mx-auto mt-6 max-w-3xl font-title text-3xl font-black leading-tight tracking-[-0.035em] md:text-6xl">
            Empieza hoy a organizar tu membresia familiar
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-8 text-white/72 md:text-lg">
            Crear tu membresia toma pocos minutos. Elige tu plan, registra tus datos y deja organizada la informacion familiar desde tu celular.
          </p>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <button
              onClick={() => setModalOpen(true)}
              className="inline-flex min-h-[54px] items-center justify-center gap-2 rounded-full bg-white px-8 py-4 text-base font-black text-[#534AB7] transition-transform hover:scale-[1.02]"
            >
              Crear mi membresia
              <i className="ri-arrow-right-line text-lg" />
            </button>
            <a
              href="https://wa.me/526675680042?text=Hola%2C%20quiero%20informacion%20sobre%20Coverly"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-[54px] items-center justify-center gap-2 rounded-full border border-white/25 px-8 py-4 text-base font-black text-white transition-colors hover:bg-white/10"
            >
              <i className="ri-whatsapp-line text-lg" />
              Hablar con un asesor
            </a>
          </div>
          <div className="mt-7 flex flex-wrap justify-center gap-3 text-xs font-bold text-white/70">
            <span>Desde $289 al mes</span>
            <span>Sin contratos forzosos</span>
            <span>Datos protegidos</span>
            <span>Registro digital</span>
          </div>
        </div>
      </section>
      <RegistrationModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
